import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      {/* Core Expertise Section */}
      <div className="section-with-image">
        <div className="image-container">
          <img src={process.env.PUBLIC_URL + 'assets/customer-satisfaction.png'} alt="Core Expertise" />
        </div>
        <div className="text-container">
          <h2>Core Expertise</h2>
          <p>
            <strong>NextOrbitals</strong> excels in web development, creating dynamic and responsive websites that enhance user experiences and drive business growth. The team is skilled in utilizing the latest technologies and frameworks to build robust, secure, and scalable web applications.
            In addition to web development, NextOrbitals offers specialized services in developing Hospital Management Systems and Restaurant Management Applications. These solutions are designed to streamline operations, improve efficiency, and enhance customer satisfaction in their respective industries.
          </p>
          <p>
            <strong>Hospital Management Systems:</strong> NextOrbital’s solutions simplify complex healthcare 
            workflows, enabling hospitals to manage patient records, appointments, billing, and inventory seamlessly.
            The applications are configured with AI-powered tools such as predictive analytics for patient care, 
            chatbots for instant customer support, and machine learning algorithms for optimizing resource 
            allocation and staff scheduling.
          </p>
          <p>
            <strong>Restaurant Management Applications:</strong> The company provides intuitive and feature-rich 
            applications that help restaurants manage orders, reservations, inventory, and customer relationships
            effectively. These applications are enhanced with AI-driven tools like personalized recommendation 
            engines, sentiment analysis for customer feedback, and automated inventory management systems that 
            predict stock requirements based on historical data.
          </p>
        </div>
      </div>

      {/* Why NextOrbitals Section */}
      <div className="section-with-image reverse">
        <div className="image-container2">
            <img src={process.env.PUBLIC_URL + 'assets/Web-Dvelopment-Company-in-India.png'} alt="Why NextOrbitals" />
        </div>
        <div className="text-container">
          <h2>Why NextOrbitals?</h2>
          <p>
            NextOrbitals stands out as a trusted partner for businesses seeking to leverage technology for growth. 
            The company’s commitment to <strong>innovation</strong>, <strong>quality</strong>, and <strong>customer satisfaction </strong> 
            has earned it a reputation as a leader in the industry.
            With a team of <strong>skilled professionals</strong> and a <strong>passion for excellence</strong>, NextOrbitals continues to deliver 
            transformative solutions that drive success for its clients.
            Whether it’s building a state-of-the-art website, developing customized management systems, or integrating 
            advanced AI tools, NextOrbitals is dedicated to helping businesses thrive in the digital age. 
            By combining technical expertise with cutting-edge AI capabilities, NextOrbitals ensures that its solutions 
            are at the forefront of technological innovation.
          </p>
        </div>
      </div>

      {/* About Us Section */}
      <div className="about-us">
        <h2>About Us</h2>
        <p>
          Founded in 2025, Provides IT consulting and software development services. 
          Clients respect us for unfailing budget and time control, cooperation transparency, and consistently high service quality. 
          <strong> NextOrbitals</strong> is a forward-thinking technology organization specializing in innovative web development and custom software solutions. 
          With a strong focus on delivering high-quality, scalable, and user-centric applications, <strong>NextOrbitals</strong> has established itself as a top-leading organization in the tech industry. 
          The company is dedicated to empowering businesses by providing cutting-edge digital solutions tailored to their unique needs, while seamlessly integrating advanced AI tools to enhance functionality and efficiency.
        </p>
      </div>
    </section>
  );
};

export default About;